<template>
  <d-modal size="lg" @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('product.addProduct') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="add-product-to-container-form" tag="form">
          <d-row>
            <d-col cols="9">
              <div class="form-group">
                <label>
                  {{ $t('product.productName') }}:
                </label>

                <validation-provider
                  name="product_id"
                  v-slot="{ errors }">
                  <select-product
                    :productID="null"
                    :returnProductNameAndCode="true"
                    :class="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </d-col>

            <d-col cols="3">
              <div class="form-group">
                <label>
                  {{ $t('ui.amount') }}:
                </label>

                <validation-provider
                  rules="required|min:1"
                  name="qty"
                  v-slot="{ errors }">
                  <d-input-group :append="$t('ui.piecesAbbr')">
                    <d-input
                      type="number"
                      :min="1"
                      :step="1"
                      :state="errors.length ? 'invalid' : null"
                      v-model="qty" />
                  </d-input-group>
                </validation-provider>
              </div>
            </d-col>
          </d-row>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('product.addProduct') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import SelectProduct from './../common/SelectProduct.vue';

export default {
  name: 'add-product-to-container-popup',
  components: {
    'select-product': SelectProduct
  },
  data () {
    return {
      productID: null,
      productName: '',
      productCode: '',
      qty: 0
    };
  },
  mounted () {
    this.$bus.$on('ui-select-product-updated', this.handleProductChange);
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-add-product-to-container-popup');
    },
    validateForm () {
      FormUtils.validate(this.$refs['add-product-to-container-form'], this.addProduct);
    },
    cancel () {
      this.handleClose();
    },
    addProduct () {
      let formDataToSend = {
        product_id: this.productID,
        qty: this.qty,
        product_name: this.productName,
        product_code: this.productCode
      };

      this.$bus.$emit('container-add-product', formDataToSend);
      this.handleClose();
    },
    handleProductChange (dataToUse) {
      this.productID = dataToUse.productID;
      this.productName = dataToUse.productName;
      this.productCode = dataToUse.productCode;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-product-updated', this.handleProductChange);
  }
}
</script>
